import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {MultiSelect} from 'primereact/multiselect';
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";

const SchedulegroupFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [machines, setMachines] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    data = {name: data.name, type: data.type, time_from: formData.time_from || null, time_until: formData.time_until || null,
      machines: (formData.machines || []).map(machine => typeof machine === 'object' ? machine.id : machine)};
    setLoading(true)
    if (id) {
      apiCall('patch', '/api/v2/schedule-group/' + id, data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderSchedulegroupList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/production/schedule-group/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/schedule-group', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderSchedulegroupList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/production/schedule-group/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', '/api/v2/machine?item_per_page=9999').then(response => setMachines(response.data.data.items || []))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));
    if (id) {
      setLoading(true);
      apiCall('get', '/api/v2/schedule-group/' + id)
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"action-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-md-8 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-md-4 p-lg-4"}>
              <Field name="type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="type"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldType')}</label>
                  <span className="p-d-block">
                      <Dropdown options={window.App.sortDropdownOptions([
                        {
                          name: 'Munkavállalók beosztása',
                          value: 'EMPLOYEE_CAPACITY'
                        },
                        {
                          name: 'Berendezés kapacitás beosztása',
                          value: 'MACHINE_CAPACITY'
                        },
                        {
                          name: 'Berendezés és munkavállalók beosztása',
                          value: 'MACHINE_EMPLOYEE_CAPACITY'
                        }
                      ], "name")}
                                optionLabel="name"
                                optionValue="value"
                                id={"type"}
                                disabled={formData.id}
                                emptyMessage={t('noTypeYet')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    type: e.value,
                                    machines: e.value === 'EMPLOYEE_CAPACITY' ? [] : formData.machines
                                  })
                                }}
                                value={formData.type}
                                showClear
                      />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className="p-grid">
            {['time_from', 'time_until'].map(field => <div className="p-field p-col-12 p-md-6" key={field}>
              <label htmlFor={field} className="p-d-block">{t(field === 'time_from' ? 'capacityTimeFrom' : 'capacityTimeUntil')}</label>
              <InputText id={field} type="time" value={formData[field] || ''} onChange={e => setFormData({...formData, [field]: e.target.value})}/>
            </div>)}
            <div className="p-field p-col-12 p-fluid">
              <label htmlFor="capacity-machines">{t('capacityAllowedMachines')}</label>
              <MultiSelect inputId="capacity-machines" options={machines} optionLabel="name" optionValue="id" filter
                disabled={formData.type === 'EMPLOYEE_CAPACITY'}
                value={(formData.machines || []).map(machine => typeof machine === 'object' ? machine.id : machine)}
                onChange={e => setFormData({...formData, machines: e.value})}/>
              <small>{t('capacityGroupHelp')}</small>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'schedule-group' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(SchedulegroupFormComponent);
